import React from 'react';
import {
  CondensedHeader,
  Flashy,
  Gutter,
  Icon,
  Layout,
  LayoutItem,
  List,
  ListItem,
  Well,
} from '@axiom/ui';

import { RegionalPhoneNumbers } from './SupportContactsModal.const';

export const SupportContactsModalTechnicalIssue = () => {
  return (
    <div data-test="SUPPORT_CONTACTS_TECHNICAL_ISSUE">
      <CondensedHeader>Service Desk - Regional Numbers</CondensedHeader>
      <Gutter bottom="8px" />
      <List>
        {RegionalPhoneNumbers.map(({ region, number }, index) => (
          <ListItem key={region} name={`REGIONAL_PHONE_${index}`}>
            <Layout direction="horizontal">
              <LayoutItem fluid>
                <Flashy bold>{region}</Flashy>
              </LayoutItem>
              <LayoutItem>{number}</LayoutItem>
            </Layout>
          </ListItem>
        ))}
      </List>
      <Gutter bottom="16px" />
      <Well background="light blue" name="EMAIL_SUPPORT">
        <Layout>
          <LayoutItem rightGutter="16px">
            <Flashy color="controlActiveSecondary">
              <Icon name="envelope-filled" />
            </Flashy>
          </LayoutItem>
          <LayoutItem rightGutter="16px" fluid>
            <CondensedHeader>Email Support</CondensedHeader>
            <Gutter bottom="8px" />
            <a
              data-test="EMAIL_SUPPORT_LINK"
              href="mailto:support@axiomlaw.com"
            >
              support@axiomlaw.com
            </a>
          </LayoutItem>
        </Layout>
      </Well>
      <Gutter bottom="16px" />
      <Well background="light blue" name="CHAT_IT_SUPPORT">
        <Layout>
          <LayoutItem rightGutter="16px">
            <Flashy color="controlActiveSecondary">
              <Icon name="envelope-filled" />
            </Flashy>
          </LayoutItem>
          <LayoutItem rightGutter="16px" fluid>
            <CondensedHeader>Chat with IT Now</CondensedHeader>
            <Gutter bottom="8px" />
            Open the <Flashy bold>Chat with IT Now</Flashy> application on your
            desktop to start a live support session.
          </LayoutItem>
        </Layout>
      </Well>
      <Gutter bottom="16px" />
      <Well background="light blue" name="RESET_PASSWORD_SUPPORT">
        <Layout>
          <LayoutItem rightGutter="16px">
            <Flashy color="controlActiveSecondary">
              <Icon name="avatar" />
            </Flashy>
          </LayoutItem>
          <LayoutItem rightGutter="16px" fluid>
            <CondensedHeader>Reset Your Password</CondensedHeader>
            <Gutter bottom="8px" />
            Password expired or locked out? Reset it yourself from any device at{' '}
            <a
              data-test="RESET_PASSWORD_LINK"
              href="http://passwordreset.axiomlaw.com"
              target="_blank"
              rel="noreferrer"
            >
              passwordreset.axiomlaw.com
            </a>
          </LayoutItem>
        </Layout>
      </Well>
    </div>
  );
};
